import { ChannelType, DeviceType } from '../../../types';

export enum InfoPageType {
  UNDEFINED = 'UNDEFINED',
  CHANNEL = 'CHANNEL',
  INSERVICE = 'INSERVICE',
  VISIBILITY = 'VISIBILITY',
  INPUT_TYPE = 'INPUT_TYPE',
  CALIBRATION = 'CALIBRATION',
}

export type ConfigurationHook = {
  autoCalibrate: () => void;
  editChannel: (values: ChannelGeneralConfiguration) => void;
  swapInDevice: () => void;
  swapOut: () => void;
  updateRecoveryDevice: () => void;
  updateDevice: () => void;
  updateDevices: () => void;
  setDeviceName: (name: string) => void;
  calibrateLoading: boolean;
  updateDeviceLoading: boolean;
};

export type ConfigurationHookParams = {
  channel?: ChannelType;
  device?: DeviceType;
  devices?: DeviceType[];
};

export type ConfigurationFormHookParams = {
  channel?: ChannelType;
};

export type ChannelGeneralConfiguration = {
  name: string;
  icon_name: string;
  hidden: boolean;
  isPartialControlModeVisible?: boolean;
  isDailyModeVisible?: boolean;
};

export type PartialConfigChangedParams = {
  channelId: string;
  onTariffSuccess?: () => void;
};
